import React from 'react'

const PageContainer = ({children}) => {
  return (
  <div className="md:p-5 py-5 px-3 min-h-screen bg-gray-100">
      <div className="container mx-auto">
        {children}
      </div>
    </div>
  )
}

export default PageContainer
